/**
 * İçerik modülü için başlangıç durumu
 */
export const initialState = {
  // İçerik durumu
  selectedContentId: null,
  previousAssetId: null, // Proje değişikliğini takip etmek için
  contentsList: [],
  
  // Sayfalama ve sıralama
  currentPage: 1,
  totalCount: 0,
  pageCount: 1,
  itemsPerPage: 15,
  sortKey: '',
  sortOrder: 'DESC',
  
  // Filtreleme ve arama
  searchQuery: '',
  selectedFilter: null,
  
  // Görünüm yönetimi
  lastActiveView: 'list', // 'list' veya 'detail' - şu anda hangi görünümdeyiz
  
  // Önbellek yönetimi
  requestCounter: 0, // Kaç kez istek gönderildiğini takip etmek için
  cacheVersion: Date.now() % 1000, // Önbellek versiyonu - timestamp'in son 3 hanesini kullan
  lastRefreshTime: Date.now(), // Son yenileme zamanı
  lastCacheInvalidateTime: 0, // Son önbellek temizleme zamanı - gereksiz temizlikleri önlemek için
}

/**
 * Persist edilecek state özellikleri
 */
export const persistedState = [
  'selectedContentId',
  'previousAssetId',
  'currentPage',
  'sortKey',
  'sortOrder',
  'searchQuery',
  'selectedFilter',
  'lastActiveView',
  'requestCounter',
  // 'cacheVersion' - sayfa yenilendiğinde sıfırlanması için persisted etmiyoruz
  // 'lastRefreshTime' - sayfa yenilendiğinde güncellenecek
]
